<template>
    <div class="roller-out" :class="{'verticalModeChild': $store.state.compare.isVertical}" v-if="$store.state.compare.compareShowMode==='roller'">
        <div :style="{ width: width, left: left, top: top, height: height, 'z-index': $store.state.compare.zIndex}"
              class="mapDiv" id="mapRolling" @drop="drop($event,-1)" @dragover.prevent
        >
        </div>
        <div class="roller-child" @drop="drop($event, item.title)" @dragover.prevent
             :class="{ active: item.isActive, 'roller-child-top-down': $store.state.compare.isVertical, 'roller-child-left-right': !$store.state.compare.isVertical }"
             v-for="item in rollerList" :key=item.title :id="'roller'+item.title"
        >
            <div class="div-dashed" v-if="item.isLeafletOff"
                 @dragleave="rollerList[item.title].isActive=false" @dragenter="rollerList[item.title].isActive=true"
            >
                <div class="labelUp">请将图片拖至卷帘</div>
                <div class="labelBottom">仅支持卫星图和专题图</div>
            </div>
            <div
                    class="roller-title" style="z-index: 999" v-if="!item.isLeafletOff"
                    :class="{
                        rightDiv:item.title===0&&(!$store.state.compare.isVertical), leftDiv:item.title===1&&(!$store.state.compare.isVertical),
                        topDiv:item.title===0&&$store.state.compare.isVertical, bottomDiv:item.title===1&&$store.state.compare.isVertical
                    }"
            >{{item.curDataTitle}}</div>
        </div>
        <div  v-on:click="quit()">
            <img class="screen-quit" :src="'/dataLab/compareQuit.png'"/>
        </div>
    </div>
</template>
<script>
    export default {
        name: "RollerShade",
        data() {
            return {
                rollerList: [],
                top: 0, left: 0, width: "100%", height: "100%", showTopLeft: true, showBottomRight: true,
                topToBottom: undefined, leftToRight: undefined,
            }
        },
        created() {
            this.eventVue.$on("changeRoller", this.changeRoller);
        },
        mounted() {
            this.rollerList = this.$store.state.compare.rollerList;
        },
        methods: {
            async drop(event, index) {
                let item = this.$store.state.compare.dropData;
                // 检验item是否有geojson和serviceUrl
                if ( !item.dataGeojson || !item.serviceUrl ) {
                    await this.getLayerData(item);
                }
                let productName = item.name;
                let geojson = item.dataGeojson;
                let serviceUrl = item.serviceUrl;
                let mapContent = this.$store.state.compare.mapContent;
                if(index !== -1){  // 该分支为左侧卷帘，或上面卷帘
                    this.$store.state.compare.zIndex = 5;
                    this.rollerList[index].isActive = false;
                    //判断是否已经初始化过leaflet
                    if(!mapContent.baseMap) {  // 底图为空
                        mapContent.baseMap = this.utils.initMap('mapRolling', geojson, this.$store.state);
                        // 设置底图position。isVertical===true为上下卷帘
                        this.left = index === 1 && !this.$store.state.compare.isVertical? "50%": 0;        // 左右卷帘&&右半卷帘
                        this.top = index === 1 && this.$store.state.compare.isVertical? "50%": 0;          // 上下卷帘&&下卷帘
                        this.width = index === 0 && !this.$store.state.compare.isVertical? "50%": "100%";  // 左右卷帘&&左卷帘
                        this.height = index === 0 && this.$store.state.compare.isVertical? "50%": "100%";  // 上下卷帘&&上卷帘
                        // 设置卷帘图层
                        let layer = this.utils.addLayer(serviceUrl, geojson, this.$store.state);
                        if(index===0){
                            mapContent.maps["topLeft"] = layer;
                        }else{
                            mapContent.maps["bottomRight"] = layer;
                        }
                        this.$nextTick(function () {
                            mapContent.baseMap.invalidateSize(true);
                        })
                    } else{                         // 有底图
                        this.left = 0;
                        this.width = '100%';
                        this.height = '100%';
                        this.top = 0;

                        // 设置卷帘图层
                        let layer = this.utils.addLayer(serviceUrl, geojson, this.$store.state);
                        if(index===0){
                            mapContent.maps["topLeft"] = layer;
                        }else{
                            mapContent.maps["bottomRight"] = layer;
                        }
                        
                        this.$nextTick(function () {
                            mapContent.baseMap.invalidateSize(true);
                            // 初始化卷帘拖动分割线。isVertical===true为上下卷帘
                            if(this.$store.state.compare.isVertical){
                                this.topToBottom = this.L.control.SideBySideVertical(mapContent.maps["topLeft"], mapContent.maps["bottomRight"]).addTo(mapContent.baseMap);
                            }else{
                                this.leftToRight = this.L.control.sideBySide(mapContent.maps["topLeft"], mapContent.maps["bottomRight"]).addTo(mapContent.baseMap);
                            }
                        })
                    }
                    // 设置页面
                    this.rollerList[index].isLeafletOff = false;
                    this.rollerList[index].curDataTitle = productName;
                }else{   // 这是右卷帘，或下卷帘
                    let idx = 0;
                    let layer = this.utils.addLayer(serviceUrl, geojson, this.$store.state);
                    if(this.$store.state.compare.isVertical){   // 如果是上下卷帘
                        if(!this.topToBottom){
                            // 无垂直分隔符，即只有一个切片, 以下是替换图层, 以下处理移动的操作
                            let dividerVertical = document.getElementsByClassName('leaflet-sbs-divider-vertical');
                            let midBarY = 0;
                            if (dividerVertical.length > 0) {
                                midBarY = parseFloat(dividerVertical[0].style.top.replace('px',''));
                            } else {
                                midBarY = document.getElementsByClassName('verticalModeChild')[0].clientHeight / 2;
                            }
                            let offsetY = event.offsetY;
                            // 先替换旧的图层，再重新设置边界
                            if(offsetY <= midBarY){
                                mapContent.layerGroup.removeLayer(mapContent.maps["topLeft"]);
                                mapContent.maps["topLeft"] = layer;
                                idx = 0;
                            }else{
                                mapContent.layerGroup.removeLayer(mapContent.maps["bottomRight"]);
                                mapContent.maps["bottomRight"] = layer;
                                idx = 1;
                            }
                            this.utils.calcCoordinates(mapContent.baseMap, geojson);
                        } else {  // 此时底图偏向一侧
                            this.utils.calcCoordinates(mapContent.baseMap, geojson);
                            if(!this.rollerList[0].isLeafletOff){
                                mapContent.maps["topLeft"] = layer;
                                idx = 0;
                            }else{
                                mapContent.maps["bottomRight"] = layer;
                                idx = 1;
                            }
                        }
                    } else {  //如果是左右卷帘
                        if(this.leftToRight){
                            let offsetX = event.offsetX;
                            let midBarX = parseFloat(document.getElementsByClassName('leaflet-sbs-divider')[0].style.left.replace('px',''));
                            if(offsetX <= midBarX){
                                mapContent.layerGroup.removeLayer(mapContent.maps["topLeft"]);
                                mapContent.maps["topLeft"] = layer;
                                this.leftToRight.setLeftLayers(mapContent.maps["topLeft"]);
                                idx = 0;
                            }else{
                                mapContent.layerGroup.removeLayer(mapContent.maps["bottomRight"]);
                                mapContent.maps["topLeft"] = layer;
                                this.leftToRight.setRightLayers(mapContent.maps["bottomRight"]);
                                idx = 1;
                            }
                        } else {
                            this.utils.calcCoordinates(mapContent.baseMap, geojson);
                            if(!this.rollerList[0].isLeafletOff){  // 底图在左上
                                mapContent.layerGroup.removeLayer(mapContent.maps["topLeft"]);
                                mapContent.maps["topLeft"] = layer;
                                idx = 0;
                            }else{  // 底图在右下
                                mapContent.layerGroup.removeLayer(mapContent.maps["bottomRight"]);
                                mapContent.maps["bottomRight"] = layer;
                                idx = 1;
                            }
                        }
                    }
                    // 设置页面
                    this.rollerList[idx].isLeafletOff = false;
                    this.rollerList[idx].curDataTitle = productName;
                }
            },
            quit(){
                this.$store.state.myLabFucChecked = 0;
                this.utils.quitCompare(this.$store.state.compare);
            },
            changeRoller(){
                let mapContent = this.$store.state.compare.mapContent;
                if(this.$store.state.compare.isVertical){
                    if (this.leftToRight){
                        this.leftToRight.remove();
                    }
                    if (Object.keys(mapContent.maps["topLeft"]).length!==0 || Object.keys(mapContent.maps["bottomRight"]).length!==0){
                        this.topToBottom = this.L.control.SideBySideVertical(mapContent.maps["topLeft"], mapContent.maps["bottomRight"]).addTo(mapContent.baseMap);
                    }
                }else{
                    if (this.topToBottom){
                        this.topToBottom.remove();
                    }
                    if (Object.keys(mapContent.maps["topLeft"]).length!==0 || Object.keys(mapContent.maps["bottomRight"]).length!==0){
                        this.leftToRight = this.L.control.sideBySide(mapContent.maps["topLeft"], mapContent.maps["bottomRight"]).addTo(mapContent.baseMap);
                    }
                }
            },
            getLayerData(item){
                return this.axios.get("/highmanage/seniorProductMgr/getProductServiceDetailById", {
                    params: {
                        productId: item.internalDemandId
                    }
                }).then(res => {
                    item.dataGeojson = JSON.parse(res.data.data.geo);
                    let symbol = res.data.data.serviceUrl.indexOf('?') === -1? "?": "&&";
                    item.serviceUrl = res.data.data.serviceUrl + symbol + "token=" + this.$store.state.user.token;
                })
            },
        }
    }
</script>
<style scoped>
    @import url('../../plugins/layout-vertical.css');
    @import url('../../plugins/range-vertical.css');
    @import url('../../plugins/range.css');
    .roller-out {
        position: absolute;
        top: 0px;
        width: 100%;
        height: 100%;
        background-color: #000000B2;
        display: flex;
    }
    .labelUp{
        font-size: .24rem;
        color: rgba(234,234,234,1);
        margin: .1rem;
    }
    .labelBottom{
        font-size:.14rem;
        color: rgba(151,151,151,1);
        margin: .1rem;
    }
    .mapDiv{
        display: flex;
        flex-direction: row;
        position: absolute;
        top: 0;
        height: 100%;
        width: 100%;
    }
    .verticalModeChild{
        flex-direction: column;
    }
    .roller-child{
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        overflow: hidden;
    }
    .roller-child-top-down{
        width: 100%;
        height: 50%;
    }
    .roller-child-left-right{
        width: 50%;
        height: 100%;
    }
    .rightDiv{
        left: 25%;
    }
    .leftDiv{
        right: 25%;
    }
    .topDiv{
        left: 50px;
        top: 40%;
    }
    .bottomDiv{
        left: 50px;
        top: 60%;
    }
    .screen-quit{
        position: absolute;
        right: 0;
        top: 0;
        width: 2rem;
        height: 2rem;
        z-index: 999;
        cursor: pointer;
    }
    .roller-title {
        position: absolute;
        top: 0rem;
        padding: 0.3rem 1rem;
        background: rgba(36,51,56,0.77);
        font-size: 14px;
        box-shadow: 1px 1px 3px 0 rgba(0,0,0,0.5);
        border-radius: 6px;
        color: white;
        z-index: 999;
        text-align: center;
        overflow: hidden; /*内容超出宽度时隐藏超出部分的内容 */
        text-overflow: ellipsis;/* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用。*/
        white-space: nowrap; /*不换行 */
    }
    .div-dashed{
        border:1px dashed #C9C9C9;
        height: 96%;
        width: 96%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
    }
</style>